import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { FontSyncService } from '@ui/tablo-generator/child-name/font-sync.service';
import { BehaviorSubject } from 'rxjs';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import { first, switchMap } from 'rxjs/operators';

@Component({
    selector: 'lib-child-name',
    templateUrl: './child-name.component.html',
    styleUrls: ['./child-name.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChildNameComponent implements OnInit, OnDestroy {
  @Input() name;

  @ViewChild('container', { static: true }) container;

  currentFontSize$ = new BehaviorSubject<number>(1);
  @Input() set fontSize(fontSize: number) {
    this.currentFontSize$.next(fontSize);
  }
  private changes: MutationObserver;
  @Input() @Required context: string;
  constructor(
    private fontSyncService: FontSyncService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    const element = this.container.nativeElement;
    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      mutations
        .filter(
          (mutation) =>
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style',
        )
        .forEach((mutation) => {
          this.currentFontSize$
            .pipe(
              switchMap((v) =>
                // @ts-ignore
                document.fonts.ready.then(() => v),
              ),
              first(),
            )
            .subscribe((currentFontSize: number) => {
              this.fontSyncService.reportResult(
                this.context,
                element.clientWidth <= this.elementRef.nativeElement.clientWidth
                  ? element.clientHeight <=
                    this.elementRef.nativeElement.clientHeight
                    ? currentFontSize
                    : currentFontSize *
                      (this.elementRef.nativeElement.clientHeight /
                        element.clientHeight)
                  : currentFontSize *
                      (this.elementRef.nativeElement.clientWidth /
                        element.clientWidth),
              );
            });
        });
    });
    this.changes.observe(element, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  ngOnDestroy(): void {
    this.changes?.disconnect();
  }
}
